import {
  GetUserQuery,
  GetUserQueryVariables,
  PaginationSort,
  UserGroup,
  UserStatus,
} from '../gql/graphql';
import { TypedDocumentNode, useQuery } from '@apollo/client';

import { graphql } from '../gql';

export const GET_USERS = graphql(`
  query getUser(
    $filters: UserFilterInput
    $pagination: PaginationRequest
    $sort: PaginationSort
  ) {
    users(filters: $filters, pagination: $pagination, sort: $sort) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          username
          firstName
          lastName
          authUsername
          userId
          createdAt
          updatedAt
          status
        }
      }
    }
  }
`);

type QueryProps = {
  username?: string;
  fullName?: string;
  userGroups?: UserGroup[];
  status?: UserStatus;
  enabled?: boolean;
  pageSize?: number;
  sort?: PaginationSort | null;
  networkOnly?: boolean;
};

export function useGetUsers({
  userGroups,
  username,
  fullName,
  enabled = true,
  pageSize = 50,
  sort = null,
  networkOnly = false,
}: QueryProps) {
  const filters: GetUserQueryVariables['filters'] = {
    groups: userGroups,
    status: UserStatus.Active,
  };
  if (username) filters.username = username;
  if (fullName) filters.fullName = fullName;

  const { loading, error, data, fetchMore } = useQuery(
    GET_USERS as TypedDocumentNode<GetUserQuery, GetUserQueryVariables>,
    {
      variables: {
        pagination: { first: pageSize, after: 0 },
        filters,
        sort,
      },
      skip: !enabled,
      fetchPolicy: 'network-only',
    }
  );

  const hasNextPage = data?.users?.pageInfo?.hasNextPage ?? false;

  return {
    error,
    loading,
    data,
    fetchMore,
    hasNextPage,
  };
}
